// @ts-check
/* ═══════════════════════ DELING TIL SOSIALE MEDIER ═══════════════════════
   Ærlig om plattformene:
   - Instagram & Snapchat har INGEN web-API for å poste direkte fra en
     nettside. Eneste vei er telefonens delings-ark (Web Share API) →
     bruker velger Instagram/Snapchat der. Funker best med et BILDE
     (deles rett til Stories). Krever altså mobil/PWA.
   - Facebook/Messenger kan deles både fra mobil (delings-ark) og PC
     (sharer-lenke som deler URL-en — Facebook tar ikke imot forhåndsutfylt
     tekst lenger, kun lenken + dens OG-forhåndsvisning).
   Strategi: prøv native deling (bilde først), fall tilbake til
   Facebook-sharer + kopier-lenke på PC.
   ═══════════════════════════════════════════════════════════════════════ */

export const PUBLIC_FOLG_URL = 'https://usa26.kolakowski.no/folg';

function isShareSupported(){
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}
function canShareFiles(files){
  try { return isShareSupported() && typeof navigator.canShare === 'function' && navigator.canShare({ files }); }
  catch { return false; }
}

/** Gjør en bilde-URL om til en File for native deling (Stories). */
async function photoToFile(url){
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) return null;
    const blob = await res.blob();
    if (!blob.type || !blob.type.startsWith('image/')) return null;
    return new File([blob], 'reise.jpg', { type: blob.type || 'image/jpeg' });
  } catch { return null; }
}

export function facebookShareUrl(url = PUBLIC_FOLG_URL){
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

/**
 * Del et dagbok-øyeblikk. Returnerer:
 *  'shared'    — delt via native delings-ark
 *  'cancelled' — bruker avbrøt delings-arket
 *  'fallback'  — ingen native deling (PC) → kaller bør vise FB + kopier-lenke
 * @param {{ title?:string, text?:string, photoUrl?:string|null }} opts
 * @returns {Promise<'shared'|'cancelled'|'fallback'>}
 */
export async function shareMoment({ title, text, photoUrl } = {}){
  const caption = [title, text].filter(Boolean).join(' — ').trim().slice(0, 280);
  const payload = {
    title: 'Canada & Alaska 2026',
    text: caption ? `${caption}\n\nFølg reisen vår:` : 'Følg reisen vår:',
    url: PUBLIC_FOLG_URL,
  };

  // 1) Native deling MED bilde — best for Instagram/Snapchat Stories
  if (photoUrl) {
    const file = await photoToFile(photoUrl);
    if (file && canShareFiles([file])) {
      try {
        await navigator.share({ files: [file], title: payload.title, text: payload.text });
        return 'shared';
      } catch (e) {
        if (e && e.name === 'AbortError') return 'cancelled';
        // faller videre til tekst-deling
      }
    }
  }

  // 2) Native deling av tekst + lenke (Facebook/Messenger/WhatsApp via arket)
  if (isShareSupported()) {
    try {
      await navigator.share(payload);
      return 'shared';
    } catch (e) {
      if (e && e.name === 'AbortError') return 'cancelled';
    }
  }

  // 3) PC: ingen delings-ark → la kaller håndtere Facebook + kopier-lenke
  return 'fallback';
}

/** Kopier en lenke til utklippstavlen. Returnerer true ved suksess. */
export async function copyLink(url = PUBLIC_FOLG_URL){
  try { await navigator.clipboard.writeText(url); return true; }
  catch { return false; }
}
